import { createSlice } from "@reduxjs/toolkit";

interface IInitialState {
  info: { idTokenClaims: { oid: string }; homeAccountId: string };
}

const initialState: IInitialState = {
  info: { idTokenClaims: { oid: "" }, homeAccountId: "" },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setInfo: (state, action) => {
      state.info = action.payload;
    },
  },
});

export const selectStateAuth = (state) => state.auth.info;
export const selectAuthHomeAccountID = (state) => state.auth.info.homeAccountId;
export const selectAuthUserID = (state) => state.auth.info.idTokenClaims.oid;

export const { setInfo } = authSlice.actions;

export default authSlice.reducer;
